import { portalPaths } from '@provision/portal-routes';

export enum BillingTab {
  Invoices = 'invoices',
  StripeAccount = 'stripe-account',
}

export const BILLING_TAB_PARAM = 'tab';

/** Settings › Billing opened on a given tab, for links from other pages. */
export const billingTabPath = (tab: BillingTab) =>
  `${portalPaths.settings.billing()}?${BILLING_TAB_PARAM}=${tab}`;
